import config from "../config";
import Labels from "../services/apiLabels";
import { getAuthUserId } from "./userIdentity";

/** Contact fields used by the evaluation “Get my valuation” form. */
export function pickEvaluationContact(source = {}) {
  const user = source.user || {};
  const first =
    source.firstname ||
    source.first_name ||
    user.firstname ||
    user.first_name ||
    "";
  const last =
    source.lastname ||
    source.last_name ||
    user.lastname ||
    user.last_name ||
    "";
  const name =
    [first, last].filter(Boolean).join(" ").trim() ||
    source.username ||
    user.username ||
    "";
  const email = String(source.email || user.email || "").trim();
  const mobile = String(
    source.mobile_number ||
      source.phone ||
      source.mobile ||
      user.mobile_number ||
      user.phone ||
      user.mobile ||
      ""
  ).trim();
  const postcode = String(
    source.postcode ||
      source.postal_code ||
      user.postcode ||
      user.postal_code ||
      ""
  )
    .trim()
    .toUpperCase();

  return { name, email, mobile, postcode };
}

function unwrapProfileUser(response) {
  const payload = response?.data || response || {};
  return (
    payload?.user ||
    payload?.data?.user ||
    (payload?.data && typeof payload.data === "object" && !Array.isArray(payload.data)
      ? payload.data
      : null) ||
    payload
  );
}

/** Load full profile so phone/postcode (often missing from login) can autofill. */
export async function fetchEvaluationProfileContact(auth) {
  const token = auth?.token;
  const userId = getAuthUserId(auth);
  if (!token || !userId) return pickEvaluationContact(auth || {});

  try {
    const response = await fetch(
      `${config.baseUrl}${Labels.getupdateprofile}${userId}/`,
      {
        method: "GET",
        headers: {
          Authorization: `Token ${token}`,
          Accept: "application/json",
        },
      }
    );
    const json = await response.json();
    const user = unwrapProfileUser(json) || {};
    return pickEvaluationContact({ ...auth, ...user, user });
  } catch (e) {
    return pickEvaluationContact(auth || {});
  }
}

export function getMissingEvaluationContactFields({
  user_name,
  user_email,
  user_postcode,
  user_mobile_number,
  labels = {},
}) {
  const missing = [];
  if (!String(user_name || "").trim()) {
    missing.push(labels.name || "Your Name");
  }
  if (!String(user_email || "").trim()) {
    missing.push(labels.email || "Your Email");
  }
  if (!String(user_postcode || "").trim()) {
    missing.push(labels.postcode || "Your Postcode");
  }
  if (!String(user_mobile_number || "").trim()) {
    missing.push(labels.mobile || "Your Mobile Number");
  }
  return missing;
}

export function getMissingEvaluationVehicleFields({
  reg_number,
  mileage,
  previous_owners,
  services_history,
  labels = {},
}) {
  const missing = [];
  if (!String(reg_number || "").trim()) {
    missing.push(labels.reg || "Registration Number");
  }
  if (!mileage?.isSelected) {
    missing.push(labels.mileage || "Mileage");
  }
  if (!previous_owners?.isSelected) {
    missing.push(labels.owners || "Previous Owners");
  }
  if (!services_history?.isSelected) {
    missing.push(labels.service || "Services History");
  }
  return missing;
}
